import { useState } from "react"
import Chevron from "@/common/icons/chevron"
import Blocks from "@/components/Blocks"
import Block from "@/components/wrappers/block"
import styles from "./accordion.module.css"
import classNames from "classnames"

export default function Accordion({ block, settings }) {
  const classes = ["accordion", styles.accordion, settings?.innerAlign].concat(
    block.attrs.classList
  )
  const [hidden, setHidden] = useState(true)

  const chevronClasses = [styles.chevron, hidden ? "" : "transform rotate-180"]
  const buttonClasses = [styles.button]
  const childSettings = {
    "core/buttons": { width: "bleed" },
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "core/list": { width: "bleed" },
    "core/quote": { width: "bleed" }
  }

  if (block.innerBlocks.length === 0 || block.attrs.heading.length === 0) {
    return null
  }

  return (
    <Block
      id={block.attrs?.slug}
      block={block}
      width="column"
      gap="none"
      className={classNames(classes)}>
      <header className={styles.header}>
        <h2 className={styles.headline}>{block.attrs.heading}</h2>
        <div
          onClick={() => setHidden(!hidden)}
          className={classNames(buttonClasses)}>
          <Chevron className={classNames(chevronClasses)} />
        </div>
      </header>

      <div
        className={classNames(styles.content, {
          "hidden on-print": hidden
        })}>
        <Blocks blocks={block.innerBlocks} settings={childSettings} />
      </div>
    </Block>
  )
}
